import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Handles the return from Emergent Google sign-in (#session_id=...)
export default function GoogleCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true });
        await refresh();
        if (!data.paid) toast.error(`Non troviamo un acquisto del planner per ${data.email}. Usa l'email con cui hai acquistato.`);
        nav(data.paid ? "/dashboard" : "/", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Accesso con Google non riuscito. Riprova.");
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center" data-testid="google-callback">
      {error ? (
        <>
          <div className="text-[#C48B97] text-sm" data-testid="google-callback-error">{error}</div>
          <button onClick={() => nav("/", { replace: true })} className="text-sm underline text-[#58635B]" data-testid="google-callback-home">
            Torna alla pagina iniziale
          </button>
        </>
      ) : (
        <div className="font-serif-display italic text-[#8FA087]">un momento…</div>
      )}
    </div>
  );
}
